<template>
	<div class="filter appointments" >
		<div class="filter-item">
			<span @click="changeType('appointments')">Afspraken</span>
			<ToggleField
				type="radio"
				name="type"
				:checked="currentType === 'appointments'"
				@change="changeType('appointments')"
			/>
		</div>
		<div class="filter-item">
			<span @click="changeType('historic')">Verleden</span>
			<ToggleField
				type="radio"
				name="type"
				:checked="currentType === 'historic'"
				@change="changeType('historic')"
			/>
		</div>
		<h1 class="thermo">Filter</h1>
		<template v-if="currentType !== 'historic'">
			<div class="filter-item">
				<span @click="changeFilter('all')">Alle afspraken</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === 'all'"
					@change="changeFilter('all')"
				/>
			</div>
			<div
				v-for="day in daysOfTheWeek"
				:key="day.value"
				class="filter-item"
			>
				<span @click="changeFilter(day.value)">{{ day.name }}</span>
				<ToggleField
					type="radio"
					name="filter"
					:checked="currentFilter === day.value"
					@change="changeFilter(day.value)"
				/>
			</div>
		</template>
		<div class="historic-input-container" v-if="currentType === 'historic'">
			Van <DateField v-model="historicFromDate" @change="emitFilterChange()"></DateField>
			T/m <DateField v-model="historicTillDate" @change="emitFilterChange()"></DateField>
		</div>
		<h1 class="thermo">ACCOUNTMANAGER</h1>
		<div class="filter-item" v-for="agent in agents" v-if="agent.employee.id != null">
			<span @click="setAgentFilter(agent.employee.id)">{{ getEmployeeName(agent) }}</span>
			<ToggleField
				type="radio"
				:name="'agentFilter' + agent.employee.id"
				:checked="agentFilter.includes(agent.employee.id)"
				@click="setAgentFilter(agent.employee.id)"
			/>
		</div>
	</div>
</template>

<script>
import DateField from "@/components/DateField.vue";
import ToggleField from "@/components/ToggleField.vue";
import moment from "moment";
import {mapActions, mapState} from "vuex";

export default {
	components: {
		DateField,
		ToggleField,
	},

	props: {
		filter: String,
	},
	watch: {
		filter() {
			if(this.filter === this.currentFilter){
				return;
			}
			this.currentFilter = this.filter;
			this.emitFilterChange(this.filter);
		}
	},

	data() {
		return {
			historicFromDate: moment().subtract(5, 'days').format('DD-MM-YYYY'),
			historicTillDate: moment().subtract(1, 'days').format('DD-MM-YYYY'),
			afterDate: moment().subtract(1, "months").format("YYYY-MM-DD"),
			currentType: 'appointments',
			currentFilter: 'all',
			agentFilter: []
		};
	},

	beforeMount() {
		this.fetchAgents();

		this.currentFilter = this.daysOfTheWeek[0].value;
	},

	mounted() {
		this.emitFilterChange(this.currentFilter);
	},

	computed: {
		...mapState('data', {
			agents: 'agents',
		}),

		daysOfTheWeek() {
			const days = [];

			for (let i = 0; i < 7; i++) {
				const day = moment().locale("nl").add(i, "day");
				const dayName = day.format("dddd");

				if (["zaterdag", "zondag"].indexOf(dayName) === -1) {
					days.push({
						name: dayName.charAt(0).toUpperCase() + dayName.slice(1),
						value: day.format("YYYY-MM-DD")
					});
				}
			}

			return days;
		},
	},
	methods: {
		...mapActions({
			fetchAgents: 'data/fetchAgents',
		}),

		changeType(type) {
			this.currentType = type;
			this.emitFilterChange();
		},

		changeFilter(filter) {
			this.currentFilter = filter;
			this.emitFilterChange();
		},

		emitFilterChange() {
			this.$emit('filterChange', {
				filter: this.currentFilter,
				type: this.currentType,
				afterDate: this.afterDate,
				historicFromDate: this.historicFromDate,
				historicTillDate: this.historicTillDate,
				agentFilter: this.agentFilter.length > 0 ? this.agentFilter : null
			});
		},

		setAgentFilter(agentId) {
			if (this.agentFilter == null) {
				this.agentFilter = [];
			}
			if(this.agentFilter.includes(agentId)){
				this.agentFilter = this.agentFilter.filter(id => id !== agentId);
				this.emitFilterChange(this.currentFilter);
				return;
			}
			this.agentFilter.push(agentId);
			this.emitFilterChange(this.currentFilter);
		},

		getEmployeeName(agent) {
			if (agent.display_name != null && agent.display_name !== '') {
				return agent.display_name;
			}

			let name = agent.employee.firstname;
			if (agent.employee.infix != null && agent.employee.infix !== '') {
				name += ' ' + agent.employee.infix;
			}
			return name + ' ' + agent.employee.lastname;
		},
	}
};
</script>

<style scoped lang="scss">
.filter-item {
	display: flex; justify-content: space-between; margin-bottom: 0.5em;
}
</style>
